var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCompras(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 34 34",
    style: {
      enableBackground: "new 0 0 34 34"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#02404F;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M30.8,13.7V7.2c0-0.2-0.1-0.5-0.1-0.7c0-0.2-0.1-0.3-0.3-0.5l-1-0.8c-0.3-0.3-0.7-0.4-1.1-0.4l-2.4,0V4.8 c0-0.9-0.3-1.7-0.8-2.4C24.3,1.5,23.2,1,22.1,1c-1.1,0-2.2,0.5-2.9,1.4c-0.5,0.7-0.8,1.5-0.8,2.3v0.1l-0.5,0V3.2 c0-0.5-0.4-0.9-0.9-0.9h-2.4c0.1-0.5,0.1-1-0.2-1.5c-0.2-0.4-0.7-0.7-1.2-0.7c-0.7,0.1-1.3,0.3-1.8,0.8c-0.1-0.1-0.1-0.1-0.2-0.2 C10.7,0.3,10.1,0,9.5,0C8.8,0,8.2,0.3,7.9,0.9c-0.3,0.4-0.3,1-0.1,1.4c0,0,0,0,0,0H5.3c-0.5,0-0.9,0.4-0.9,0.9v8.5 c0,0.1,0,0.1,0,0.2l-1.1,1.4c0,0,0,0,0,0c-0.1,0.1-0.1,0.2-0.1,0.3C3.1,14,3,14.3,3,14.6v17.1C3,33,4,34,5.3,34h23.5 c1.3,0,2.3-1,2.3-2.3V14.6C31,14.3,30.9,14,30.8,13.7z M15.2,7.3h3.2v0.3c0,0.5,0.4,0.9,0.9,0.9s0.9-0.4,0.9-0.9V7.3h4v0.3 c0,0.5,0.4,0.9,0.9,0.9c0.5,0,0.9-0.4,0.9-0.9V7.3h3.2v4.1c-0.2-0.1-0.4-0.1-0.6-0.1l-13.2,0V7.3z M20.1,4.7c0-0.5,0.2-0.9,0.4-1.3 c0.4-0.5,0.9-0.7,1.5-0.7c0.6,0,1.2,0.2,1.6,0.7c0.3,0.4,0.4,0.8,0.5,1.3v0.1l-4,0V4.7z M16.1,4.8l-0.1,0c-0.4,0-0.8,0.1-1.2,0.4 l-1,0.8c-0.2,0.1-0.2,0.3-0.3,0.5c-0.1,0.2-0.1,0.4-0.1,0.6v4l-1.4,0V4h4.1V4.8z M10.3,4v7.2l-4.1,0V4H10.3z M29.3,31.7 c0,0.3-0.3,0.6-0.6,0.6H5.3c-0.3,0-0.6-0.3-0.6-0.6v-17h24.6V31.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M17,20.8c1.4,0.1,2.8-0.6,3.7-1.7c0.6-0.9,1-1.9,1-3c0-0.5-0.4-0.9-0.9-0.9S20,15.7,20,16.2 c0,0.7-0.2,1.4-0.6,1.9c-0.5,0.7-1.4,1.1-2.3,1c-0.9,0-1.8-0.3-2.3-1c-0.4-0.6-0.7-1.2-0.7-1.9c0-0.5-0.4-0.9-0.9-0.9 s-0.9,0.4-0.9,0.9c0,1.1,0.4,2.1,1,3C14.2,20.3,15.6,20.9,17,20.8z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompras);
export default __webpack_public_path__ + "static/media/Compras.2ad23fc5320789941514616d84db1ae5.svg";
export { ForwardRef as ReactComponent };